export default __webpack_public_path__ + "static/media/icon-image.afa9e557.svg";